// AI 챗봇 추천 질문 (aiSearchPage, MainInquirySection 공용)
// 하나 바이블 공과 질문(공과 데이터로 즉답)과 자료 찾기 질문(자료 검색)을 섞어 둔다.
export const CHATBOT_QUESTIONS = [
  "이번 주 공과 보여 줘",
  "6과정 2학기 35과 알려 줘",
  "하나 바이블이 뭐예요?",
  "아이들이 자주 다퉈요. 어떤 공과가 좋을까요?",
  "어린이 주일학교 콘텐츠 추천해 주세요",
  "재미있는 성경공부 활동 자료를 찾고 있어요",
  "교사 교육 영상을 찾고 있어요",
  "유아부 교육 자료를 찾고 있어요",
  "중고등부 수련회 프로그램 자료를 추천해 주세요",
  "새신자 교육용 콘텐츠가 필요해요",
  "구역예배 공과 콘텐츠를 추천해 주세요",
  "여름성경학교 콘텐츠를 알려 주세요",
  "절기 행사 자료를 찾고 있어요",
  "찬양 악보와 음원 자료를 찾고 싶어요",
  "하나 바이블 초등부 공과 자료를 찾고 있어요",
  "하나 바이블 유치부 단원송 자료를 찾고 있어요",
];

// 추천 질문 중 count개를 무작위로 뽑는다 (Fisher-Yates 셔플)
export const pickChatbotQuestions = (count = 4) => {
  const shuffled = [...CHATBOT_QUESTIONS];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled.slice(0, count);
};
